// ==============================
//* LOGINTOREGISTER
//
//? This file add script for login page comportment.
// ==============================

// setup swap login part to register part
const setupLoginSwap = {
    selectors: {
        loginPart: ".js-login, .js-register",
        goTo: ".js-go-to-login, .js-go-to-register"
    },
    class: {
        none: "d-none"
    },

    init() {
        let $loginParts = $(this.selectors.loginPart);
        let $goTo = $(this.selectors.goTo);

        $goTo.on("click", () => {
            $loginParts.toggleClass(this.class.none);
        });
    }
};
setupLoginSwap.init();
